import React, { useContext, useEffect, useState } from 'react';
import LinkMediaVideoHeader from './LinkMediaVideoHeader';
import GallerySection from './GallerySection';
import VideoController from './VideoController';
import PlayAllButton from './PlayAllButton';
import TitleSubtitleUpdate from './TitleSubtitleUpdate';
import { useNavigate, useParams } from 'react-router-dom';
import { Context } from "../contexts/AppContext";
import { deleteData, getData } from '../../lib/utils';
import AudioPlayer from './AudioPlayer';
import Icons from "../Icons/index";
import ImageController from './ImageController';

const isGalleryId = (input) => /^[0-9a-fA-F]{24}$/.test(input);

const LinkMedia = () => {
  const { galleryId: identifier } = useParams();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const [temp, setTemp] = useState("ChapterListModal");
  const PropertyObj = Icons[temp];

  // 🔹 iOS detection
  const [isIOS, setIsIOS] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
   const { galleryId } = useParams();
   const navigate = useNavigate();

  useEffect(() => { 
    
    (async () => {
      const data = await getData("Videos/getCaptureVideoId");
      if(data){
        console.log("XXXXXXXXXXXXXXXx ",data.videoIds)
        data.videoIds.map((item,index)=>{
          
          localStorage.removeItem(`thumb_${item}`)
        },[]);
         const res = await deleteData(`Videos/clearCaptureVideoIds`);
         if(res)
         {
          console.log("DDDDDDDDD")
         }

      }
      
    })();
  }, []);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      setIsIOS(true);
    }
  }, []);

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  useEffect(() => {
    if (modalOpen.type === "ChapterListModal") {
      setTemp("ChapterListModal");
    } else if (modalOpen.type === "DownloadVideoModal") {
      setTemp("DownloadVideoModal");
    } else if (modalOpen.type === "WatchOnTvModal") {
      setTemp("WatchOnTvModal");
    }
    else if (modalOpen.type === "PhotoThumbnailModal") {
         
      setTemp("PhotoThumbnailModal");
      
    }
  }, [modalOpen?.isOpen]);

   const openPhotoGallery = () => {

  // window.history.pushState(
  //   { photoGallery: true },
  //   ""
  // );

  // setAppState((prevState) => {
  //   return {
  //     ...prevState,
  //     modalData: {
  //       ...prevState.modalData,
  //       type: "PhotoThumbnailModal",
  //       isOpen: true,
  //     },
  //   };
   // });
    navigate(
        `/photos/${galleryId}`
      );
};
  // Fetch gallery data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data;
        if (isGalleryId(identifier)) {
          data = await getData(`galleries/gallery/${identifier}`);
        } else {
          data = await getData(`galleries/gallery/customurl/${identifier}`);
        }

        localStorage.setItem('title', data?.gallery?.title);
        if (data) {
          console.log("DDDDDDDDDDDDDDDDDDDD ",data)
          setAppState((prevState) => ({
            ...prevState,
            folder: data.folder,
            gallery: data.gallery,
            currentGalleryData: data.gallery,
            videos: data.videos,
            photos: data.photos,
            backgroundMedia: data?.gallery?.backgroundMedia,
            videoArr: data.videos || [],
            currentGalleryVideoTitle: data.gallery?.title || "",
            currentGalleryVideoSubTitle: data.gallery?.subtitle || "",
            currentFontFamilyVideoTitle: data.gallery?.fheading || "",
            currentFontFamilyVideoSubTitle: data.gallery?.fbody || "",
          }));

          const response = await getData(
            `admin/admin-details-client/${data.folder.adminId}`
          );

          if (response) {
            if (window.injectBrandingAssets) {
              window.injectBrandingAssets(
                response?.admin?.id,
                data.gallery._id,
                process.env.REACT_APP_VIDEO_DEST_BASE_PATH,
                process.env.REACT_APP_API_PATH,
                response?.admin?.companyFaviconUrl,
                response?.admin?.companyLogoUrl,
                data?.gallery?.backgroundMedia?.imgUrl,
                data?.gallery?.title
              );
            }
            setAppState((prevState) => ({
              ...prevState,
              adminDetails: response.admin,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [identifier, setAppState]);

  useEffect(() => {
    const handleMessage = (event) => {
       
     console.log(event.data?.selectedVideos,' ........message............... ',event.data?.captrueImage );
 

      if (typeof event.data === "object" && event.data !== null) {
        setAppState((prevState) => ({
          ...prevState,
          ...event.data,
          
        }));
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [appState, setAppState]);

  const templateId = Number(appState?.currentGalleryData?.templateid);

  return (
    <>
      {/* 🔹 Show Start button only on iOS and not started yet */}
      {isIOS && !isStarted ? (
        <div className="flex flex-col justify-center items-center min-h-screen">
          <button
            onClick={() => {
              setIsStarted(true);
              window.dispatchEvent(new Event("iphonePlayAllowed")); // trigger thumbnails
            }}
            className="px-6 py-3 bg-yellow-700 text-white rounded-lg text-lg shadow-md hover:scale-105 transition"
          >
            Start Preview
          </button>
          <p className="mt-3 text-gray-300 text-sm">
            Tap to enable video thumbnails
          </p>
        </div>
      ) : (
        <>
          {/* Background only loads after Start click on iOS OR all devices on non-iOS */}
          <div className="fixed inset-0 -z-10 w-full h-full">
            {appState.currentGalleryData?.backgroundMedia?.imgUrl && <ImageController />}
            {appState.currentGalleryData?.backgroundMedia?.videoUrl && <VideoController />}
          </div>

          <div
            className="min-h-screen flex flex-col h-screen relative z-10 overflow-y-auto"
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            <header className="text-white px-4">
              {templateId === 0 && appState?.currentGalleryData && (
                <div className='w-full'>
                  <LinkMediaVideoHeader appState={appState} />
                </div>
              )}
              {templateId === 1 && appState?.currentGalleryData && (
                <div style={{ width: 'calc(100% - 430px)' }}>
                  <LinkMediaVideoHeader appState={appState} />
                </div>
              )}
              <TitleSubtitleUpdate />
            </header>

              <main className="flex w-full justify-between px-10">
                
              {appState?.videos?.length > 1 &&
                appState?.currentGalleryData?.setting?.playall && <PlayAllButton />
              }

              {appState?.currentGalleryData?.backgroundMedia?.musicUrl && (
                <AudioPlayer
                  id="musicplayer"
                  musicPath={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.currentGalleryData?.backgroundMedia?.musicUrl}`}
                />
                )}
              
                {appState?.photos?.length > 0 &&
 
                  <button onClick={openPhotoGallery} className="bg-[#1f2937] hover:bg-[#1f2937] text-white px-5 py-2 rounded-full cursor-pointer whitespace-nowrap flex items-center gap-2 transition">
                    Photos
                  </button>
                }

            </main>

            {templateId === 2 && appState?.currentGalleryData ? (
              <div className="absolute top-0 right-0 h-full z-20 p-4">
                <GallerySection />
              </div>
            ) : (
              <footer className="text-white mt-auto  md:overflow-x-auto ">
                 <GallerySection />
              </footer>
            )}
          </div>
        </>
      )}

      {modalOpen.isOpen && (
        <div id="MODAL_POPUP" className="relative z-20">
          <PropertyObj />
        </div>
      )}
    </>
  );
};

export default LinkMedia;
